export interface IPicturesEntries {
  entities: {
    pictures: { [id: string]: IPicture };
  };
  result: {
    data: string[];
  };
}

export interface IPictureEntries {
  entities: {
    pictures: { [id: string]: IPicture };
  };
  result: {
    data: string;
  };
}

export enum PICTURE_FORMAT {
  BIG = 'BIG',
  BIG_THUMBNAIL = 'BIG_THUMBNAIL',
  MEDIUM = 'MEDIUM',
  ORIGINAL = 'ORIGINAL',
  PROFILE_PORTRAIT = 'PROFILE_PORTRAIT',
  SMALL = 'SMALL',
}

export type IPictureFormat =
  | PICTURE_FORMAT.BIG
  | PICTURE_FORMAT.BIG_THUMBNAIL
  | PICTURE_FORMAT.MEDIUM
  | PICTURE_FORMAT.ORIGINAL
  | PICTURE_FORMAT.PROFILE_PORTRAIT
  | PICTURE_FORMAT.SMALL;

export interface ISimplePicture {
  id: string;
  source: string;
}

export interface IPicture {
  id: string;
  attributes: {
    aboid: string;
    isMainPicture: boolean;
    isOnModeration: boolean;
    formats: { [type in IPictureFormat]: string };
  };
}
